import ImageSilder from "./components/imageSilder";
import { Add_cart, List, ListSVG, Sub_cart, cart, cart_MA } from "../../../../assets/icons";
import CartListView from "./components/cartListView";
import { useEffect, useRef, useState } from "react";
import useAppAccessor from "../../../../hooks/useappAccessor";
import { set } from "lodash";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { setProductsInCart } from "../../interaction.actions";
import { postCheckout } from "../../../../services/shopcom.service";
import CartSVG from "./components/cartSVG";
import DollarSVG from "./components/dollarSVG";
import { languageMap } from "./map/language";
import { countryMap } from "./map/country";
import { getBrandColor } from "../../../../utils/brand.util";


const decimalComponent = (number: any) => {

  if (number == undefined) return;
  if (number.includes("-")) {
    const numb1: any = number.toString().split("-")[0];
    const numb2: any = number.toString().split("-")[1];
    const [integerPart, decimalPart] = numb1.toString().split(".");
    const [integerPart_2, decimalPart_2] = numb2.toString().split(".");

    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart ? `${integerPart}.` : `${integerPart}`}
          {decimalPart ? <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart}`}</span> : <span> </span>
          }
        </div>
        -
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15, marginLeft: 5 }}
        >
          {decimalPart_2 ? `${integerPart_2}.` : `${integerPart_2}`}
          {decimalPart_2 ? <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_2}`}</span> : <span> </span>
          }
        </div>
      </div>
    );
  } else if (number.includes(",")) {
    const [integerPart_3, decimalPart_3] = number.toString().split(",");
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart_3
            ? `${integerPart_3},`
            : `${integerPart_3}`}
          {decimalPart_3 ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart_3}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
      </div>
    );
  } else {
    var [integerPart_3, decimalPart_3] = number.toString().split(".");
    if (decimalPart_3.includes(" ")) {
      decimalPart_3 = decimalPart_3.split(" ")[0];
    }
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart_3
            ? `${integerPart_3}.`
            : `${integerPart_3}`}
          {decimalPart_3 ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart_3}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
      </div>
    );
  }
};





const InteractionShoppingCart = (props: any) => {
  const [qtyNumber, setQtyNumber] = useState(1)
  const [totalNum, setTotalNum] = useState(1)
  const [isShowCart, setIsShowCart] = useState(props.showCart ?? false)
  const [images, setImages] = useState<any>([]);
  const [mainImage, setMainImage] = useState<any>("");
  const [currentOption, setCurrentOption] = useState<any>(null);
  const { getInteractions, getUserData, getLiveMainData } = useAppAccessor()
  const { joinWithAttendeeData } = getLiveMainData();
  const { client, referrer_user } = getUserData();
  const { productDetail, productsInCart } = getInteractions();
  const [displayShortDes, setDisplayShortDes] = useState(false);
  const dispatch = useAppDispatch();
  const [showSelection, setShowSelection] = useState(false);
  const [selectedOption, setSelectedOption] = useState(false);
  const [added, setAdded] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  const [maskHeight, setMaskHeight] = useState(document.getElementById('idVideoRoomContainer')?.offsetHeight ?? 2500)


  const elementRef = useRef<HTMLDivElement>(null);
  const [elementHeight, setElementHeight] = useState<number>(625);

  useEffect(() => {
    if (elementRef.current) {
      setElementHeight(elementRef.current.offsetHeight);
    }
  }, []);

  useEffect(() => {
    const iFrameContainer = document.getElementById('iFrameContainer');
    if (iFrameContainer) {
      iFrameContainer.scrollTop = 0;
    }
  }
    , [isShowCart]);


  const handleAddToCartClick = () => {
    setShowSelection(true); // 显示选中部分
    addToCart();
    if (productDetail && productDetail?.options && productDetail?.options.length > 0) {
      let cartProducts = productsInCart;
      if (cartProducts.find((item: any) => item.sku === productDetail?.options[0].sku)) {
        setAdded(true);
      } else {
        setAdded(false);
      }
    }
    setTimeout(() => {
      setShowSelection(false); // 5秒后隐藏选中部分
    }, 5000);
  };

  useEffect(() => {
    var total = 0;
    productsInCart.map((item: any) => {
      total += item.quantity;
    })
    setTotalNum(total);
  }, [isShowCart])

  useEffect(() => {
    // console.log("productsInCart in redux====>Main",productsInCart)
    var total = 0;
    productsInCart.map((item: any) => {
      total += item.quantity;
    })
    setTotalNum(total);
  }, [productsInCart])

  useEffect(() => {
    if (ref.current) {
      const height = ref.current.offsetHeight;
      if (document.getElementById('idVideoRoomContainer')?.offsetHeight) {
        if (document.getElementById('idVideoRoomContainer')!.offsetHeight >= height) {
          setMaskHeight(document.getElementById('idVideoRoomContainer')!.offsetHeight + 200);
        }
      }
    }
  }, [displayShortDes]);

  useEffect(() => {
    if (ref.current) {
      const height = ref.current.offsetHeight;
      if (document.getElementById('idVideoRoomContainer')?.offsetHeight) {
        if (document.getElementById('idVideoRoomContainer')!.offsetHeight >= height) {
          setMaskHeight(document.getElementById('idVideoRoomContainer')!.offsetHeight + 200);
        }
      }
    }
  }, []);



  useEffect(() => {
    console.log("productDetail Data in redux====>Main",productDetail);
    let imagesArr: any[] = [];
    // productDetail?.options?.map((item:any)=>{
    //   item?.images?.map((p:any) => {
    //     imagesArr.push(p.sizes[0].url);
    //   })
    // });

    setMainImage(productDetail?.imageUrl);

    if (productDetail?.options && productDetail?.options.length == 1) {
      setCurrentOption(productDetail?.options[0]);

      let imagesArr: any[] = [productDetail?.imageUrl];
      if (currentOption && currentOption.images) {
        currentOption.images?.map((item: any) => {
          // item?.images?.sizes.map((p:any) => {
          imagesArr.push(item.sizes[0].url);
          // })
        });
      }
      setMainImage(imagesArr[0]);
      setImages(imagesArr);
      if (productDetail && productDetail?.options && productDetail?.options.length > 0) {
        let cartProducts = productsInCart;
        if (cartProducts.find((item: any) => item.sku === productDetail?.options[0].sku)) {
          setAdded(true);
        } else {
          setAdded(false);
        }
      }
    } else {
      setImages([]);
      setCurrentOption(null);
    }
  }, [productDetail])

  useEffect(() => {

    if (productDetail?.fromCarsoul) {
      // if (isShowCart) {
      setIsShowCart(false);
      // } else {
      //   setIsShowCart(true);
      // }
    }
  }, [productDetail])

  useEffect(() => {
    if (currentOption && currentOption.images) {
      let imagesArr: any[] = [productDetail?.imageUrl];
      currentOption.images?.map((item: any) => {
        // item?.images?.sizes.map((p:any) => {
        imagesArr.push(item.sizes[0].url);
        // })
      });
      setMainImage(imagesArr[0]);
      setImages(imagesArr);
    }
  }, [currentOption]);

  const addToCart = () => {
    if (currentOption) {
      let cartProducts = productsInCart;
      if (cartProducts.find((item: any) => item.sku === currentOption.sku)) {
        setAdded(true);
        cartProducts = cartProducts.map((item: any) => {
          if (item.sku === currentOption?.sku) {
            return {
              ...item,
              quantity: item.quantity + qtyNumber
            }
          }
          return item;
        })
      } else {
        setAdded(false);
        let product = {
          id: productDetail?.id,
          name: productDetail?.name,
          price: currentOption?.price,
          priceString: currentOption?.priceString,
          sku: currentOption?.sku,
          quantity: qtyNumber,
          imageUrl: productDetail?.imageUrl,
          options: currentOption,
        }
        cartProducts.push(product);
        setTimeout(() => {
          var total = 0;
          productsInCart.map((item: any) => {
            total += item.quantity;
          })
          setTotalNum(total);
        }, 1000);
      }
      dispatch(setProductsInCart(cartProducts));
    }
  }

  const handleQtyOnclick = (isIncrease: boolean) => {
    if (isIncrease) {
        setQtyNumber(qtyNumber + 1);
    } else {
      if (qtyNumber > 1) {
        setQtyNumber(qtyNumber - 1);
      }
    }
  };

  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [checkoutUrl, setCheckoutUrl] = useState("");

  // 检查出模态框组件
  const CheckoutModal = ({ url, onClose }: { url: string; onClose: () => void }) => {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '10px',
          padding: '20px',
          width: '90%',
          maxWidth: '400px',
          textAlign: 'center'
        }}>
          <h3 style={{ margin: '10px 0 20px' }}>Complete your checkout</h3>
          <p style={{ margin: '10px 0', fontSize: '14px' }}>
            Click the button below to open checkout in a new tab
          </p>
          <div style={{ margin: '20px 0' }}>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                padding: '10px 20px',
                backgroundColor: getBrandColor(client),
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                fontWeight: 'bold'
              }}
            >
              Go to Checkout
            </a>
          </div>
          <button
            onClick={onClose}
            style={{
              marginTop: '15px',
              padding: '8px 15px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              background: 'none',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  };

  const doCheckOut = () => {
    let products: Array<any> = [];
    productsInCart.map((item: any) => {
      let options: Array<any> = [];
      options.push({ optionStringValue: item.options.name });
      products.push({
        id: item.id.toString(),
        quantity: item.quantity,
        type: 'PROD',
        userOptions: {
          appSourceId: "hussle"
        },
        option: options
      })
    })
    // 生成随机的购物车ID
    const generateRandomString = () => {
      return Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
    }

    var hostData = localStorage.getItem("hostData");
    var data = hostData?.split('_');
    var lan = languageMap[data![0].toLowerCase() as keyof typeof languageMap] ?? "eng";
    var country = countryMap[data![1].toLowerCase() as keyof typeof countryMap] ?? "usa";
    var id = `amos_${generateRandomString()}_w_${country}_${country}_${lan}`;
    let body = {
      application: "amos",
      id: id,
      language: lan,
      product_country: country,
      shipping_country: country,
      site_type: "w",
      products: products,
    };

    postCheckout(body).then((response: any) => {
      var prefix = 'https://www.shop.com/';
      if (lan == 'eng' && country == 'usa') {
        prefix = 'https://www.shop.com/';
      } else if (lan == 'eng' && country == 'gbr') {
        prefix = 'http://uk.shop.com/';
      } else if (lan == 'eng' && country == 'can') {
        prefix = 'http://ca.shop.com/';
      } else if (lan == 'eng' && country == 'aus') {
        prefix = 'http://au.shop.com/';
      } else if (lan == 'chi' && country == 'twn') {
        prefix = 'http://tw.shop.com/';
      } else if (lan == 'chi' && country == 'hkg') {
        prefix = 'http://hk.shop.com/';
      } else if (lan == 'chi' && country == 'sgp') {
        prefix = 'http://sgzh.shop.com/';
      } else if (lan == 'ind' && country == 'idn') {
        prefix = 'http://id.shop.com/';
      } else if (lan == 'eng' && country == 'idn') {
        prefix = 'http://iden.shop.com/';
      } else if (lan == 'eng' && country == 'hkg') {
        prefix = 'http://hken.shop.com/';
      } else if (lan == 'eng' && country == 'sgp') {
        prefix = 'http://sg.shop.com/';
      } else if (lan == 'msa' && country == 'mys') {
        prefix = 'http://mybm.shop.com/';
      } else if (lan == 'eng' && country == 'mys') {
        prefix = 'http://my.shop.com/';
      } else if (lan == 'chi' && country == 'mys') {
        prefix = 'http://myzh.shop.com/';
      }

      if (referrer_user != null && referrer_user?.third_party_username) {
        const url = prefix + referrer_user!.third_party_username + '/nbts/ccn_cart.xhtml?shopping_id=' + id;
        openNewTab(url);
      } else if (joinWithAttendeeData != null && joinWithAttendeeData!.issuer_metadata != null && joinWithAttendeeData?.issuer_metadata?.third_party_username) {
        const url = prefix + joinWithAttendeeData?.issuer_metadata?.third_party_username + '/nbts/ccn_cart.xhtml?shopping_id=' + id;
        openNewTab(url);
      } else {
        const url = prefix + 'nbts/ccn_cart.xhtml?shopping_id=' + id;
        openNewTab(url);
      }
    });
  }

  // 解决Safari浏览器中window.open无效的问题
  const openNewTab = (url: string) => {
    
    // 检测是否为iOS设备
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    // 检测是否为移动设备
    const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent) || isIOS;

    if (isMobileDevice) {
      // 对于移动设备，特别是Safari，显示模态框引导用户操作
      setCheckoutUrl(url);
      setShowCheckoutModal(true);
    } else {
      // 桌面浏览器使用a标签模拟点击
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      // 将a标签添加到文档中
      document.body.appendChild(link);

      // 模拟点击
      link.click();

      // 从文档中移除a标签
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
    }
  };

  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  const { language } = getUserData();
  return (
    <div ref={ref} style={{ height: maskHeight }}>
      {showCheckoutModal && (
        <CheckoutModal
          url={checkoutUrl}
          onClose={() => setShowCheckoutModal(false)}
        />
      )}
      <div className="h-16 w-full flex justify-between items-center bg-white" style={isShowCart ? {} : isMobile ? { width: '100%', position: 'fixed', borderBottom: '1px solid #e5e7eb', zIndex: 100, marginTop: '0px' } : { width: 'calc(70% / 3 - 25px)', position: 'fixed', borderBottom: '1px solid #e5e7eb', zIndex: 100 }}>
        {isShowCart ? <div className="ml-10" onClick={() => { props.toggleProductList(false); setIsShowCart(false); }} style={{ fontSize: '30px' }}><img src={ListSVG} color="black" alt="Icon" height={33} width={33} className="cursor-pointer" /></div> :
          <div className="ml-10" onClick={() => props.toggleProductList(false)} style={{ fontSize: '30px' }}>{'<'}</div>}
        <div className="flex-grow text-center">{isShowCart ? language['cart_label'] : language['shop_label']}</div>
        {!isShowCart && <div className="mr-10" style={{ cursor: 'pointer', position: 'relative' }} onClick={() => { setIsShowCart(true); }}>
          <CartSVG width="22px" stroke={getBrandColor(client)}></CartSVG>
          {(
            <div style={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              background: 'red',
              color: 'white',
              borderRadius: '50%',
              width: '16px',
              height: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px',
              fontWeight: '500'
            }}>
              {totalNum}
            </div>
          )}
        </div>}
        {/* {!isShowCart && <div className="mr-10" onClick={() => {setIsShowCart(true);}}><img src={cart} alt="Icon" height={22} width={22} className="cursor-pointer"/></div>}    */}
        {isShowCart && <div style={{ width: '22px', height: '22px' }} className="mr-10" onClick={() => { }}></div>}
        {isShowCart && <div style={{ position: 'absolute', height: '22px', top: '20px', right: '12px', fontWeight: '500' }} >{(totalNum > 1 ? `${totalNum} ${language['item_label'] == "Item" ? "Items" : language['item_label']}` : `${totalNum} ${language['item_label']} `)}</div>}
      </div>
      {!isShowCart && <div className="h-full w-full bg-white" style={{ position: 'relative' }}>
        {showSelection && <div ref={elementRef} style={isMobile ? { zIndex: 10009, background: 'white', borderRadius: '5px', position: 'fixed', top: '120px', left: '10px', height: '70px', width: 'calc(100% - 20px)' } : { zIndex: 10009, background: 'white', borderRadius: '5px', position: 'fixed', top: '120px', marginLeft: '20px', height: '70px', width: 'calc(23% - 40px)' }}
          onClick={() => setShowSelection(false)}>
          <div className="flex items-center justify-center">
            <img src={productDetail?.imageUrl} style={{ width: '50px', height: '50px', position: 'absolute', top: '10px', left: '10px', borderRadius: '5px' }}></img>
            <div style={{ width: 'calc(100% - 80px)', marginLeft: '50px', marginTop: '15px' }}>
              <div style={{ color: 'black', fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} dangerouslySetInnerHTML={{ __html: productDetail?.name }} />
              {/* <p style={{color:'black', fontSize:'14px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>{productDetail?.name}</p> */}
              <p style={{ color: getBrandColor(client), fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{language['added_to_cart']}</p>
            </div>
          </div>
        </div>}
        {showSelection && <div
          onClick={() => { setShowSelection(false) }} className="w-full" style={isMobile ? { zIndex: 10008, height: maskHeight + 'px', background: 'black', opacity: 0.25, position: 'fixed', overflowY: 'hidden', top: '-15px' } : { zIndex: 10008, height: maskHeight + 'px', background: 'black', opacity: 0.25, position: 'absolute', overflowY: 'hidden' }}></div>}
        <div style={{ height: '64px' }}></div>
        <div className="w-full h-[147px] flex items-center justify-center">
          <img src={mainImage} className="h-full"></img>
        </div>

        {(((productDetail?.options?.length > 1) && currentOption != null) || (productDetail?.options?.length == 1)) && <ImageSilder
          images={images} onChangeMainImage={(img: any) => setMainImage(img)}></ImageSilder>}
        <div id={'content'} className="pl-7 pr-7 mt-2 font-medium bg-[white]" style={{ position: 'relative' }}>
          <span className="text-[17px]">
            <div dangerouslySetInnerHTML={{ __html: productDetail?.name }} />
          </span>
          <div className="flex justify-between mt-3 mb-3">
            <span className={`text-lg text-[#595959] font-medium border border-[#979797] rounded pl-1 pr-1 pt-1 pb-1 bg-white`} >
              {currentOption != null 
                ? decimalComponent(currentOption?.priceString) 
                : (productDetail?.minimumPriceString 
                    ? decimalComponent(productDetail?.minimumPriceString + '-' + productDetail?.maximumPriceString) 
                    : decimalComponent(productDetail?.maximumPriceString))}
            </span>
            <div className=" flex border border-[#979797] rounded pl-1 pr-1 " style={{ width: '40%', height: 35 }}>
              <div onClick={() => { handleQtyOnclick(false) }} style={{ width: '25%', height: 33 }} className="bg-white flex items-center justify-center
                    border-r border-[#979797] pr-1 cursor-pointer">
                <img src={Sub_cart} className="cursor-pointer"
                  onClick={() => { handleQtyOnclick(false) }}></img>
              </div>
              <div style={{ width: '50%', height: 33 }} className="bg-white flex items-center justify-center">
                {qtyNumber}</div>
              <div onClick={() => { handleQtyOnclick(true) }} style={{ width: '25%', height: 33 }} className="bg-white flex items-center justify-center border-l border-[#979797] pl-1 cursor-pointer">
                <img src={Add_cart} className="cursor-pointer"
                  onClick={() => { handleQtyOnclick(true) }}></img>
              </div>
            </div>
          </div>
          {/* <span className="text-[17px]">Size</span> */}
          {currentOption && <div style={{ fontSize: '14px', }}>{currentOption.cashbackString} <DollarSVG width="20px" stroke={getBrandColor(client)}></DollarSVG> <span>{language['cashback_label']}</span></div>}

          {productDetail?.options?.length > 1 &&
            productDetail?.selections?.map((selection: any) => {
              return (
                <select
                  onChange={(e: any) => {
                    setSelectedOption(true);
                    setCurrentOption(productDetail?.options.find((item: any) => item.sku === e.target.value));
                    if (productDetail && productDetail?.options && productDetail?.options.length > 0) {
                      let cartProducts = productsInCart;
                      if (cartProducts.find((item: any) => item.sku === productDetail?.options[0].sku)) {
                        setAdded(true);
                      } else {
                        setAdded(false);
                      }
                    }
                  }}
                  id="countries" className="bg-white border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500
                    mt-3 mb-3">
                  {/* <option selected>Select an option</option> */}
                  {/* <option value="US">United States</option>
                        <option value="CA">Canada</option>
                        <option value="FR">France</option>
                        <option value="DE">Germany</option> */}
                  <option value="" disabled selected>{language['please_select']}</option>
                  {
                    productDetail?.options?.map((item: any) => {
                      return (
                        <>
                          <option disabled={item?.canBeAddedToCart == false} value={item?.sku}>{item?.name + ` (${item?.priceString})`}</option>
                        </>
                      )
                    })
                  }
                </select>
              )
            })
          }
          {/* <span className="text-[17px]">Select Option</span>
                    <div className="flex mt-1">
                      <div className="h-[20px] w-[20px] rounded-full bg-black"></div>
                      <div className="h-[20px] w-[20px] rounded-full bg-white ml-2 border border-black"></div>
                    </div> */}

          <div className="mt-2">
            <div className="w-full text-sm font-medium text-black overflow-auto" style={{ maxHeight: '400px' }}>
              <div dangerouslySetInnerHTML={displayShortDes ? { __html: productDetail?.shortDescription } : { __html: productDetail?.description }} />
              {displayShortDes && productDetail?.shortDescription.endsWith('...') && <p style={{ color: getBrandColor(client), fontSize: '14px', cursor: 'pointer' }} onClick={() => setDisplayShortDes(false)}>{language['see_details']}</p>}
            </div>

          </div>
        </div>

        {isMobile && <div className="w-full flex items-center justify-center pt-2 pb-2 bg-white">

          <button className="pl-6 pr-6 pt-2 pb-2 rounded-full text-white text-sm font-semibold"
            style={selectedOption || productDetail?.options?.length == 1 ? { backgroundColor: getBrandColor(client), opacity: 1, position: 'fixed', bottom: '60px', width: isMobile ? '150px' : 'calc(22.5% - 15px)', left: isMobile ? 'calc(50% - 75px)' : 'auto', transform: isMobile ? 'none' : 'none', zIndex: 10 } : { backgroundColor: getBrandColor(client), opacity: 0.5, position: 'fixed', bottom: '60px', width: isMobile ? '150px' : 'calc(22.5% - 15px)', left: isMobile ? 'calc(50% - 75px)' : 'auto', right: 'calc(5% + 10px)', transform: isMobile ? 'none' : 'none', zIndex: 10 }}
            onClick={() => { if (selectedOption || productDetail?.options?.length == 1) handleAddToCartClick(); }}>{added ? language['update_cart'] : language['add_to_cart']}</button>
        </div>}
        {!isMobile && <div style={{ paddingBottom: '80px' }}></div>}

        {!isMobile && <div className="w-full flex items-center justify-center pt-2 pb-2 bg-white" style={{ position: 'fixed', bottom: '60px', width: isMobile ? 'calc(100%)' : 'calc(22.5% - 15px)', left: isMobile ? '50%' : 'auto', right: 'calc(5% + 10px)', transform: isMobile ? 'translateX(-50%)' : 'none', zIndex: 10 }}>
          <button className="pl-6 pr-6 pt-2 pb-2 rounded-full text-white text-sm font-semibold"
            style={selectedOption || productDetail?.options?.length == 1 ? { backgroundColor: getBrandColor(client), opacity: 1, minWidth: '160px' } : { backgroundColor: getBrandColor(client), opacity: 0.5, minWidth: '160px' }}
            onClick={() => { if (selectedOption || productDetail?.options?.length == 1) handleAddToCartClick(); }}>{added ? language['update_cart'] : language['add_to_cart']}</button>
        </div>}
      </div>}
      {isShowCart && <div className="h-full w-full  bg-white " style={{ position: 'relative' }}>
        {productsInCart.length > 0 ? <CartListView checkoutElem={

          isMobile ?
            <div className="w-full flex items-center justify-center pt-2 pb-2" style={totalNum > 0 ? { opacity: 1, marginTop: '50px', position: 'fixed', bottom: '60px', width: '150px', left: 'calc(50% - 75px)' } : { opacity: 0.5, left: 'calc(50% - 75px)', marginTop: '50px', position: 'fixed', bottom: '60px', width: '150px' }}>
              <button style={{ backgroundColor: getBrandColor(client) }} className="pl-6 pr-6 pt-2 pb-2 rounded-full text-white text-sm font-semibold"
                onClick={() => { doCheckOut(); }}>CheckOut</button>
            </div> :
            <div className="w-full flex items-center justify-center pt-2 pb-2" style={{ position: 'fixed', bottom: '60px', width: isMobile ? 'calc(100%)' : 'calc(22.5% - 15px)', left: isMobile ? '50%' : 'auto', right: 'calc(5% + 10px)', transform: isMobile ? 'translateX(-50%)' : 'none', zIndex: 10, background: 'white', paddingTop: '8px', paddingBottom: '8px' }}>
              <button style={{ backgroundColor: getBrandColor(client), minWidth: '160px' }} className="pl-6 pr-6 pt-2 pb-2 rounded-full text-white text-sm font-semibold"
                onClick={() => { doCheckOut(); }}>CheckOut</button>
            </div>
        }></CartListView> : <div style={{ marginTop: '0px', textAlign: 'center' }}>{language['no_items']}</div>}

      </div>}
    </div>
  )
}

export default InteractionShoppingCart;